<template>
  <div class="common-table">
    <div style="padding-top: 10px">共搜索到 {{ pageInfo.total }} 条数据</div>
    <div style="padding: 10px 0">
      <el-tag v-for="(item,index) in batchAction" :key="index"
        style="cursor: pointer;margin-right:10px"
        size="mini"
        :type="item.type||'info'"
        effect="dark"
        @click="item.action"
        >{{item.text}}</el-tag
      >
    </div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      @selection-change="handleSelectionChange"
      @current-change="singleSelectChange"
      stripe
      style="width: 100%"
      min-height="300"
      size="mini"
      :highlight-current-row="singleSelect"
    >
      <el-table-column v-if="!singleSelect" type="selection" label="全选">
      </el-table-column>
      <el-table-column type="index" label="序号" :index="indexMethod">
      </el-table-column>
      <template v-for="(c,idx) in column">
        <el-table-column v-if="c.type=='image'" :label="c.label" :width="c.width" :key="idx">
          <template slot-scope="scope">
            <div
              class="table-cell-flex"
              style="display: flex; align-items: center"
            >
              <el-image
                class="table-img"
                :src="scope.row[c.name]"
                fit="contain"
                style="width: 50px; margin-right: 10px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder" class="image-slot">
                  加载中
                  <span class="dot">...</span>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-else-if="c.type=='switch'" :label="c.label" :width="c.width" :key="idx">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row[c.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              @change="c.action(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column v-else-if="c.extend" :key="idx" :label="c.label" :width="c.width"  :formatter="c.formatter">
          <template slot-scope="scope">
            <div class="table-cell-flex">
              <img
                v-if="c.extend.type=='image'"
                :src="scope.row[c.extend.name]"
                class="table-img"
              />
              <el-avatar size="small"
                v-if="c.extend.type=='avatar'"
                :src="scope.row[c.extend.name]"></el-avatar>
              <span>{{ scope.row[c.name] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-else-if="c.copy" :key="idx" :prop="c.name" :label="c.label"  :width="c.width" :formatter="c.formatter">
          <template slot-scope="scope">
            <span>{{scope.row[c.name]}}</span>
            <el-link
                type="primary"
                v-clipboard:copy="scope.row[c.name]"
                v-clipboard:success="onCopy"
              >复制</el-link>
          </template>
        </el-table-column>
        <el-table-column v-else  :key="idx" :prop="c.name" :label="c.label"  :width="c.width" :formatter="c.formatter" show-overflow-tooltip></el-table-column>
      </template>
      <el-table-column v-if="rowAction" :label="rowAction.label" :width="rowAction.width" :fixed="rowAction.fixed">
        <template slot-scope="scope">
          <slot :rowData="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import qs from "qs";
export default {
  name: "common-table",
  props: {
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rowAction:{
      type:Object,
      default:()=>{
        return undefined;
      }
    },
    singleSelect:{
      type:Boolean,
      default:false
    },
    api:{
      type:String,
      default:''
    },
    method:{
      type:String,
      default:'post'
    },
    searchForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    postQuery: {
      type: Object,
      default: () => {
        return {};
      },
    },
    callback: {
      type: Function,
      default:()=>{}
    },
    batchAction: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading:false,
      multipleSelection:[],
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    getData() {
      if(!this.api){
        return;
      }
      this.tableLoading = true;
      const f = res=>{
        this.tableLoading = false;
        this.tableData = res.data.list||[];
        this.pageInfo.total = res.data.total;
        this.callback(res,this.tableData)
      }
      const filterForm = Object.assign({},this.searchForm)
      if(filterForm.orderStatus=='-1'){
        delete filterForm.orderStatus
      }
      delete filterForm.provinceAndCityAndCounty;
      delete filterForm.category;
      delete filterForm.times;
      if(this.method==='post'){
        this.$httpRequest.post(this.api+'?'+qs.stringify(Object.assign(this.postQuery,this.pageInfo)),filterForm).then(f).catch(e=>this.tableLoading=false);
      }
      if(this.method==='get'){
        const data = Object.assign(this.pageInfo,filterForm);
        this.$httpRequest.get(this.api+'?'+qs.stringify(data)).then(f).catch(e=>this.tableLoading=false);
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    onCopy(e) {
      this.$message.success("已复制到剪贴板");
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getData();
    },
    dateFormatter(row, column, cellValue, index) {
      return utils.dateFormat(cellValue);
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
      this.$emit("selection-change",val)
    },
    getMultipleSelection(){
        if(this.multipleSelection.length==0){
            this.$message.error('请选择需要批量操作的数据');
            throw new Error('请选择需要批量操作的数据')
        }
        return this.multipleSelection;
    },
    getMultipleSelectionIDS(){
        if(this.multipleSelection.length==0){
            this.$message.error('请选择需要批量操作的数据');
            throw new Error('请选择需要批量操作的数据')
        }
        return this.multipleSelection.map((d) => {
          return d.id;
        });
    },
    singleSelectChange(newVal,oldVal){
      this.$emit("single-change",{newVal,oldVal})
    }
  },
};
</script>

<style scoped lang="less">
.common-table {
  .block {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
  
  .table-img {
    width: 50px;
    height: auto;
    margin-right: 5px;
  }
  .table-cell-flex {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plugin/common-table.vue